const products = {
    title: 'Typische Abruzzo Producten',
    subtitle: 'Ontdek de authentieke smaken van onze regio',
    errorLoading: 'Fout bij laden producten',
    loginRequired: 'Log in om producten aan winkelwagen toe te voegen',
    addedToCart: 'Product toegevoegd aan winkelwagen!',
    errorAddingToCart: 'Fout bij toevoegen aan winkelwagen',
    noImage: 'Geen afbeelding beschikbaar',
    inStock: 'Op Voorraad',
    outOfStock: 'Uitverkocht',
    loginToAdd: 'Log in om toe te voegen',
    adding: 'Toevoegen...',
    addToCart: 'Toevoegen aan Winkelwagen',
    noProducts: 'Geen producten beschikbaar',
    comingSoon: 'Heerlijke producten komen binnenkort in onze winkel',
    categories: {
        cheese: 'Kazen',
        wine: 'Wijnen',
        oliveOil: 'Olijfolie',
        pasta: 'Pasta',
        salami: 'Vleeswaren',
        honey: 'Honing',
        truffle: 'Truffels'
    },
    wine: {
        montepulciano: {
            name: 'Montepulciano d\'Abruzzo DOC',
            description: 'Volle en gestructureerde rode wijn, geproduceerd met Montepulciano druiven gekweekt op de Abruzzo heuvels. Tonen van rijpe rode vruchten en zoete specerijen, perfect om te combineren met rood vlees en gerijpte kazen.'
        },
        trebbiano: {
            name: 'Trebbiano d\'Abruzzo DOC',
            description: 'DOC witte wijn geproduceerd met Trebbiano druiven. Fris en aromatisch, perfect voor visgerechten.'
        }
    },
    cheese: {
        pecorino: {
            name: 'Pecorino Romano DOP',
            description: 'Gerijpte pecorino kaas geproduceerd in Abruzzo volgens eeuwenoude traditie. Intense en aromatische smaak.'
        },
        caciocavallo: {
            name: 'Caciocavallo Silano',
            description: 'Getrokken pasta kaas geproduceerd met koemelk. Zoete smaak en elastische textuur.'
        }
    },
    oliveOil: {
        extraVergine: {
            name: 'Extra Vierge Olijfolie',
            description: 'Biologische extra vierge olijfolie geproduceerd van olijven gekweekt in Abruzzo. Fruitig en licht pittig.'
        }
    },
    pasta: {
        chitarra: {
            name: 'Pasta alla Chitarra',
            description: 'Traditionele Abruzzo pasta handgemaakt met durum tarwemeel en eieren. Karakteristiek vierkant formaat.'
        },
        lenticchie: {
            name: 'Linzen van Santo Stefano',
            description: 'Linzen gekweekt op het plateau van Santo Stefano di Sessanio. Klein en smaakvol.'
        }
    },
    salami: {
        salsiccia: {
            name: 'Leverworst',
            description: 'Traditionele Abruzzo worst bereid met varkenslever en specerijen. Intense en karakteristieke smaak.'
        }
    },
    honey: {
        castagno: {
            name: 'Kastanjehoning',
            description: 'Monoflorale kastanjehoning geproduceerd in de bergen. Intense smaak en karakteristieke donkere kleur.'
        }
    },
    truffle: {
        nero: {
            name: 'Zwarte Truffel',
            description: 'Kostbare zwarte truffel geoogst in de Abruzzo bossen. Intens aroma en onmiskenbare smaak.'
        }
    }
};

export default products;

